import { render, staticRenderFns } from "./parent_edit.vue?vue&type=template&id=4ec52faa&scoped=true&"
import script from "./parent_edit.vue?vue&type=script&lang=js&"
export * from "./parent_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec52faa",
  null
  
)

export default component.exports